import { useState } from "react"
import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from "react-query"
import { APIEndpoints } from "../constants/api-endpoints"
import { HttpRequest } from "../services/_http"
import { QueryKeys } from "./_query_keys"

export const useSettingsData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.SETTINGS, searchOptions]
    
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true) 
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Settings,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        keepPreviousData,
        onError: ()=>setkeepPreviousData(false),
        onSuccess: ()=>setkeepPreviousData(true),
        ...options
    })
}


export const useSettingsDetailData = (setting_id: any, options?: UseQueryOptions): UseQueryResult <any> => {
    const method   = 'GET'
    const queryKey = [QueryKeys.SETTINGS, setting_id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Settings}/${setting_id}`,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useUpdateSettings = (options?: any) => {
    const method = 'PUT'
    return useMutation(({data, setting_id}: {data: any, setting_id: any})=> HttpRequest({
        url: `${APIEndpoints.Settings}/${setting_id}`,
        method,
        data
    }), options)
}

export const useAddSettings = (options?: any) => {
    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Settings}`,
        method,
        data
    }), options)
}


export const useDeleteSettings = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({setting_id}: {setting_id: any})=> HttpRequest({
        url: `${APIEndpoints.Settings}/${setting_id}`,
        method
    }), options)
}
